import { Injectable } from '@angular/core';
import { RegionStorageService } from '../../region/region-storage.service';
import { HttpUrlBuilderService } from '../../http/http-url-builder.service';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class AuthorityUrlBuilderService {


  constructor(private httpUrlBuilder: HttpUrlBuilderService,
    private regionStorageService: RegionStorageService) {}


 createUrl(protocol, domain, port, path) {
   return this.httpUrlBuilder.createUrl(protocol, domain, port, path);
 }

 createImplicitPortUrl(protocol, domain, path) {
   return this.httpUrlBuilder.createImplicitPortUrl(protocol, domain, path);
 }

 createResourceUrl(configuration, resourcePath) {
   return this.createAuthorityUrl(configuration, resourcePath);
 }

 createResourceUrlWithParams(configuration, resourcePath, params) {
   return this.createAuthorityUrlWithParams(configuration, resourcePath, params);
}

 buildDomainString(configuration) {
   const region = this.loadRegion();
   if (typeof configuration === "string") {
     return configuration;
   } else {
     return configuration.regionPrefix + "." + region + "." + configuration.regionSuffix;
   }
 }

 createAuthorityUrl(configuration, resourcePath) {
   const domainString = this.buildDomainString(configuration.domain);
   if (configuration.port) {
     return this.createUrl(configuration.protocol, domainString, configuration.port, resourcePath);
   } else {
     return this.createImplicitPortUrl(configuration.protocol, domainString, resourcePath);
   }
 }

 createAuthorityUrlWithParams(configuration, resourcePath, params) {
  const domainString = this.buildDomainString(configuration.domain);
  if (configuration.port) {
    return this.httpUrlBuilder.createParamUrl(configuration.protocol, domainString, configuration.port, resourcePath, params);
  } else {
    return this.httpUrlBuilder.createImplicitPortParamUrl(configuration.protocol, domainString, resourcePath, params);
  }
}

 loadRegion() {
   return this.regionStorageService.loadRegion();
 }
}
